const version = '1.2.2'

export default version
